import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSelectedGoalId = () =>
  produce((draft: Draft<State>) => {
    draft.selectedGoalId.fetching = draft.selectedGoalId.fetching + 1;
  });

export const setSelectedGoalId = (selectedGoalId: string) =>
  produce((draft: Draft<State>) => {
    draft.selectedGoalId.data = selectedGoalId;
  });

export const finishFetchingSelectedGoalId = () =>
  produce((draft: Draft<State>) => {
    draft.selectedGoalId.fetching = draft.selectedGoalId.fetching - 1;
  });

export const disposeSelectedGoalId = () =>
  produce((draft: Draft<State>) => {
    draft.selectedGoalId.data = initialState.selectedGoalId.data;
    draft.selectedGoalId.fetching = initialState.selectedGoalId.fetching;
  });
